import React from 'react';
import { Container, Box } from '@mui/material';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import BalanceIcon from '@mui/icons-material/Balance';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import SectionHeader from './SectionHeader';
import FeatureCard from './FeatureCard';

const ProblemSection = () => {
  const problems = [
    {
      icon: HourglassEmptyIcon,
      title: "Expensive Consultants & Tools",
      description: "Traditional customer experience solutions cost $10,000+ per month and require long-term commitments."
    },
    {
      icon: BalanceIcon,
      title: "Fragmented Review Data",
      description: "Reviews are scattered across multiple platforms - impossible to get unified insights."
    },
    {
      icon: WarningAmberIcon,
      title: "Missing Sales Connection",
      description: "Customer feedback exists in isolation from sales data - no way to prioritize improvements by revenue impact."
    },
    {
      icon: VisibilityOffIcon,
      title: "Time-Consuming Manual Analysis",
      description: "Teams spend hours manually reading reviews instead of focusing on improving customer experience."
    }
  ];

  return (
    <Box sx={{
      py: { xs: 6, md: 8 },
      backgroundColor: '#ffffff'
    }}>
      <Container maxWidth="lg">
        <SectionHeader 
          title="Why Businesses Struggle with Expensive Customer Experience Solutions"
        />
        
        <Box sx={{ 
          display: 'flex', 
          flexWrap: 'wrap', 
          justifyContent: 'center', 
          gap: { xs: 2, md: 3 }, 
          mb: 6 
        }}>
          {problems.map((problem, index) => (
            <Box 
              key={index}
              sx={{ 
                flexGrow: 1, 
                flexBasis: { xs: '100%', md: 'calc(50% - 12px)' }, 
                maxWidth: { xs: '100%', md: 'calc(50% - 12px)' } 
              }}
            >
              <FeatureCard
                icon={problem.icon}
                title={problem.title}
                description={problem.description}
                variant="problem"
              />
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default ProblemSection; 